(function () {
  'use strict';

  window.StringUtils = window.StringUtils || {};

  StringUtils.randomString = function (length) {
    var text = '';
    var possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  };

  StringUtils.cleanNameForPrompt = function (name) {
    if (!name || name === '') {
      return 'User';
    }

    var cleaned = name.replace(/@/g, '').trim();

    if (cleaned === '') {
      return 'User';
    }

    return cleaned;
  };

  StringUtils.sanitizePrompt = function (prompt) {
    if (!prompt) return '';

    prompt = prompt.replace(/[\r\n]+/g, '\n');

    prompt = prompt.replace(/^\n+/, '');

    prompt = prompt.replace(/\s+$/, '');
    return prompt;
  };

  StringUtils.truncate = function (text, maxLength, suffix) {
    if (!text || text.length <= maxLength) {
      return text || '';
    }

    suffix = suffix || '...';
    return text.substring(0, maxLength - suffix.length) + suffix;
  };

  StringUtils.escapeHtml = function (text) {
    if (!text) return '';

    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  StringUtils.processMarkdown = function (text) {
    if (typeof marked === 'undefined') {
      return text;
    }

    // Check if text contains HTML img tags and art-prompt-text divs that should be preserved
    const htmlImgPattern = /<img[^>]+>/gi;
    const artPromptPattern = /<div class="art-prompt-text"[^>]*>.*?<\/div>/gi;

    const htmlImgMatches = text.match(htmlImgPattern) || [];
    const artPromptMatches = text.match(artPromptPattern) || [];

    // If we have HTML elements to preserve, replace them with placeholders
    let processedText = text;
    const htmlPlaceholders = [];

    // Preserve img tags
    htmlImgMatches.forEach((imgTag, index) => {
      const placeholder = `__IMG_PLACEHOLDER_${index}__`;
      htmlPlaceholders.push({ placeholder, element: imgTag });
      processedText = processedText.replace(imgTag, placeholder);
    });

    // Preserve art-prompt-text divs
    artPromptMatches.forEach((artDiv, index) => {
      const placeholder = `__ART_PLACEHOLDER_${index}__`;
      htmlPlaceholders.push({ placeholder, element: artDiv });
      processedText = processedText.replace(artDiv, placeholder);
    });

    if (typeof marked === 'undefined' || !marked.parse) {
      return processedText;
    }
    let parsed = marked.parse(processedText);
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = parsed;

    // Restore the original HTML elements
    if (htmlPlaceholders.length > 0) {
      htmlPlaceholders.forEach(({ placeholder, element }) => {
        tempDiv.innerHTML = tempDiv.innerHTML.replace(placeholder, element);
      });
    }

    const codeBlocks = tempDiv.querySelectorAll('pre code');
    if (codeBlocks.length > 0 && typeof hljs !== 'undefined') {
      codeBlocks.forEach((block) => hljs.highlightElement(block));
    }

    if (
      (tempDiv.innerHTML.match(/<p>/g) || []).length === 1 &&
      (tempDiv.innerHTML.match(/<\/p>/g) || []).length === 1
    ) {
      tempDiv.innerHTML = tempDiv.innerHTML.replace(/<p>|<\/p>/g, '');
    }

    tempDiv.innerHTML = tempDiv.innerHTML.replace(/[\s\n]+$/, '');

    tempDiv.innerHTML = StringUtils.convertMediaLinks(tempDiv.innerHTML);

    return tempDiv.innerHTML;
  };

  StringUtils.convertMediaLinks = function (html) {
    const mediaLinkPattern =
      /https?:\/\/[^\s<>"]+\.(jpg|jpeg|png|gif|webp|mp4|webm|mov|avi)(?:\?[^\s<>"]*)?/gi;

    return html.replace(mediaLinkPattern, function (url) {
      const extension = url
        .match(/\.(jpg|jpeg|png|gif|webp|mp4|webm|mov|avi)/i)[1]
        .toLowerCase();

      const precedingContext = html.substring(
        Math.max(0, html.indexOf(url) - 50),
        html.indexOf(url)
      );
      if (
        precedingContext.includes('<img') ||
        precedingContext.includes('<video') ||
        precedingContext.includes('src=') ||
        precedingContext.includes('href=')
      ) {
        return url;
      }

      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
        return `<img src="${url}" alt="Uploaded image" style="max-width: 300px; max-height: 200px; border-radius: 8px; cursor: pointer;" onclick="window.open('${url}', '_blank')" loading="lazy">`;
      } else if (['mp4', 'webm', 'mov', 'avi'].includes(extension)) {
        return `<video src="${url}" controls style="max-width: 300px; max-height: 200px; border-radius: 8px;" preload="metadata"></video>`;
      }

      return url;
    });
  };

  StringUtils.slugify = function (text) {
    if (!text) return '';

    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  StringUtils.hasSubscribeText = function (text) {
    if (!text) return false;

    var subscribeKeywords = [
      'subscribe',
      'subscription',
      'premium',
      'upgrade',
      'pro version',
      'paid plan',
      'billing',
    ];

    var lowerText = text.toLowerCase();
    return subscribeKeywords.some((keyword) => lowerText.includes(keyword));
  };

  StringUtils.formatFileSize = function (bytes) {
    if (bytes === 0) return '0 B';

    var k = 1024;
    var sizes = ['B', 'KB', 'MB', 'GB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };
})();
